import { Component, React, useState } from 'react'
import './nftconfirmation.css'
import firebase from 'firebase/compat/app';
import firebaseConfig, { db } from '../../fire';
import { Link, BrowserRouter,Redirect  as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import { Redirect } from 'react-router'
import axios from 'axios';
import web3 from "web3";
import { getAuth } from 'firebase/auth';

    export default class Bid_conformation extends Component {
        constructor(props) {
            super(props);
            this.state = {
                TxData: [],
                nftData: [],
                TransBid: []
                
            }
        }
        componentDidMount() {

            const walletaddress = localStorage.getItem('LAST_ACTIVE_ACCOUNT')
            const nftId = this.props.match.params.nftid;
            const nftRef = firebase
            .firestore()
            .collection("NFTs") // Collection Name
            .doc(nftId); // NFT Document Id need to be passed here
            nftRef.get().then((doc) => {
             if (!doc.exists) return;
              // setNFTData(doc.data());
              console.log("Individual NFT data:", doc.data());
              this.setState({nftData: doc.data()});
              console.log("NFT data:",this.state.nftData);
             // alert(this.state.nftData.id);
              localStorage.setItem('NFTBidId', this.state.nftData.id);
              localStorage.setItem('Collection', this.state.nftData.collection);
                localStorage.setItem('NFTBidTitle', this.state.nftData.nft_title);
             });
            const Nfturl = "https://us-central1-diginoor-3755e.cloudfunctions.net/app/NFT/all?id="+nftId;
            
            console.log(nftId);
            fetch(Nfturl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*'}
            })
            .then(res => {res.json().then(data => console.log(data))});

            var TransactionId = localStorage.getItem('TransactionId'); 
            var Bidvalue = localStorage.getItem('Bidvalue'); 
            var NFTBidId = localStorage.getItem('NFTBidId'); 
            const Nftbidtitle = localStorage.getItem('NFTBidTitle');
            console.log(TransactionId);
            //alert(TransactionId);
            this.setState({TransBid: TransactionId});
           // console.log(this.state.TransBid);
           // alert(this.state.TransBid);
           //alert(this.state.nftData);
          
               
           const storebid = firebase.firestore().collection("bids").add({
                value : Bidvalue,
                nftId : nftId,
                TxId : TransactionId,
                timestamp : firebase.firestore.FieldValue.serverTimestamp(),
                uid : firebase.auth().currentUser.uid,
                nft_title : Nftbidtitle,

           })
              .then(function(docRef) {
                console.log("Document written with ID: ", docRef.id);
                
              })
                .catch(function(error) {
                console.error("Error adding document: ", error);
              });
           return storebid;

           
                

        }
    
       
            
render(){
    
    return (

        <div className="nft-confirmation">
            <div className="confirmation-section">
                <div className="confirmation-section-col1">
                  <div className="confirmation-card">
                        <div className="confirmation-cardim">
                        { console.log("Minting_url:", this.state.nftData.nft_media_url) }
                            <img src={this.state.nftData.nft_thumb} className="confirmation-top-im"></img>
                        </div> 
                        <div className="about-top-details">
                            <p className="confirmation-card-title">{this.state.nftData.nft_title}</p>
                            <p className="confirmation-card-title1">{this.state.nftData.collection}</p>
                        </div>
                    </div>
                                    
                                    </div>
                                    <div className="confirmation-section2-col2">
                                        <h2>Happy you <br/>Bid an NFT !</h2>
                                        <p>Congratulations! Your bid has been submitted in the blockchain. Please wait for settlement soon.</p>
                                        <button className="tweet-button"><i className="fab fa-twitter"></i>Tweet it</button> 
                                        <button className="continue-button">My Bids</button>
                                        <div className="proof-auth">

                                            <a href={` https://ropsten.etherscan.io/tx/${this.state.TransBid}`} target="_blank">VIEW TRANSACTION <i className="fas fa-external-link-square-alt external"></i></a>
                                            
                                            
                                            </div>                                      
                                        </div>
                                    </div>
                                    </div>
        
    )
}
    }


